import {
  compose,
  withProps,
  branch,
} from 'recompose';
import { isNoIndex } from './WithNoIndex';
import { getStoreCode } from '../../Store/Store.APP_ENV.js';
import { getStoreLanguages } from '../Providers/StoreLanguagesApi';
import { getLocalisedPath, isDefaultLanguage } from '../Translations/TranslationHelper';

const code = getStoreCode();

// TODO use store.prouduction.js instead once the experiiment success
const testDomains = getStoreLanguages(code).map((language) => {
  const locale = (code == 'PBWW') || (code == 'PBEU') ? language.code : `${language.code}-${code.split('PB').slice(1)}`;
  var localisedPath = `${window.location.origin}/` + getLocalisedPath(language.code, isDefaultLanguage(language.code));
  return {
    domain: localisedPath,
    store: code,
    hreflang: locale
  }
});

const withHreflangTags = compose(
  withProps({ hreflangTags: document.querySelectorAll('link[rel="alternate"]') }),
);

const isDomainUnderTest = () =>
  testDomains.findIndex(domain => domain.store === getStoreCode()) > -1;

const setAttributes = (el, attrs) =>
  Object.keys(attrs).forEach(key => el.setAttribute(key, attrs[key]));

const createSingleHreflangTag = ({ domain, hreflang }) => {
  const href = domain; 
  const link = document.createElement('link');
  setAttributes(link, {
    href,
    rel: 'alternate',
    hreflang
  });
  document.head.appendChild(link);
};

const createHreflangTags = () => {
  testDomains.forEach(domain => createSingleHreflangTag(domain));
};

const getAllHreflangTags = () => document.querySelectorAll('link[rel="alternate"]');

const removeAllHreflangTags = () => {
  const hreflangTags = getAllHreflangTags();
  hreflangTags.forEach(tag => tag.remove());
};

const withCreateOrUpdateHreflangTags = compose(
  withHreflangTags,
  branch(
    isDomainUnderTest,
    withProps(({ callbacks }) => ({
      callbacks: [...callbacks, removeAllHreflangTags, createHreflangTags],
    })),
  ),
);

export const withCreateHreflangTags = compose(
  branch(
    isNoIndex,
    withProps(({ callbacks }) => ({
      callbacks: [...callbacks, removeAllHreflangTags]
    })),
    withCreateOrUpdateHreflangTags,
  )
);



// WEBPACK FOOTER //
// ./src/Common/Helmet/WithHreflang.js